export default __webpack_public_path__ + "static/media/ScienceNews.11cefcca.svg";